import { spacingPrimitive } from "./spacingPrimitive";

export const radius = {
	radius_none: spacingPrimitive[0],
	radius_xxs: spacingPrimitive["0.5"],
	radius_xs: spacingPrimitive[1],
	radius_sm: spacingPrimitive["1.5"],
	radius_md: spacingPrimitive[2],
	radius_lg: spacingPrimitive["2.5"],
	radius_xl: spacingPrimitive[3],
	radius_2xl: spacingPrimitive[4],
	radius_3xl: spacingPrimitive[5],
	radius_4xl: spacingPrimitive[6],
	radius_full: "9999px",
};
